export class AppStructureBuilderError extends Error {
}
//# sourceMappingURL=error.js.map